type FetcherArgs = Parameters<typeof fetch>;

export const defaultFetcher = (...args: FetcherArgs) =>
	fetch(...args).then(async (res: Response) => {
		// If the status code is not in the range 200-299,
		// we still try to parse and throw it.
		if (!res.ok) {
			const error: Error & { info?: any; status?: number } = new Error(
				'An error occurred while fetching the data.'
			);
			// Attach extra info to the error object.
			error.info = await res.json();
			error.status = res.status;
			throw error;
		}

		return res.json();
	});
